import { Injectable, inject } from '@angular/core';

import { ApContentService } from '@ap/content';

import { FilesValidator, NotificationMetadata } from '../file.model';
import { ReadFile } from '../read-file.model';
import { ApFileSelectorComponent } from '../selector/selector.component';

@Injectable()
export class ApExtensionValidator implements FilesValidator {
    private readonly contentService = inject(ApContentService);

    public fileSelector: ApFileSelectorComponent;

    public showNotification = false;

    public getNotification(): NotificationMetadata {
        return {
            type: 'error',
            testId: 'fileTypeError',
            content: this.contentService.get('file.selector.warning.type', {
                fileExtensions: this.fileSelector.getFileExtensionsString()
            })
        };
    }

    public validate(previousValue: ReadFile[], currentValue: ReadFile[]): boolean {
        let isValid = true;
        currentValue.forEach((file) => {
            const extension = (file.name.split('.').pop() || '').toLowerCase();
            if (this.fileSelector.acceptedFileExtensions().indexOf(extension) === -1) {
                isValid = false;
            }
        });
        this.showNotification = !isValid;
        return isValid;
    }
}
